import { titles, characteristics, aditionalFunctions } from '../data';
import Yat from '../assets/yat.png';
import '../styles/Home.scss';

function Home() {
    return (
        <div>
            <h1>{titles.TITLE_HOME}</h1>
            <div className='container'>
                <section className='app'>
                    <img src={Yat} alt='App' />
                </section>
                <div className='description'>
                    <section className='characteristics'>
                        {characteristics.map(CH => (
                            <div>
                                <ul>
                                    <li><p>{CH?.DESCRIPTION}</p></li>
                                </ul>
                            </div>
                        ))}
                    </section>
                    <section className='aditionalFunctions'>
                        <h2>{titles.TITLE_ADITIONAL_FUNCTIONS}</h2>
                        {aditionalFunctions.map(AF => (
                            <div>
                                <ul>
                                    <li><img src={AF?.IMAGE} alt='' /> <p>{AF?.FUNCTION}</p></li>
                                </ul>
                            </div>
                        ))}
                    </section>
                </div>
            </div>
        </div>
    )
}

export default Home;